export const basicAuth = {
    "Content-Type": "application/json",
    Authorization:
      "Basic " + window.btoa("Fidweb1!:Off1c3AF1dw3b2020C0R0N4FTW!"),
  };
  